<template>
  <CColor :theme>
    <CIcon :name/>
  </CColor>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CColor from '@/shared/components/CColor.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import OrderStatus from '../../constants/OrderStatus';

  const props = defineProps<{
    status: OrderStatus;
    hasSignature?: boolean;
  }>();

  const theme = computed(() => {
    switch (props.status) {
      case OrderStatus.APPROVED:
        return 'success';
      case OrderStatus.REFUSED:
        return 'danger';
      default:
        return 'neutral';
    }
  });

  const name = computed(() => {
    switch (props.status) {
      case OrderStatus.INVISIBLE:
        return 'eye-off';
      case OrderStatus.NOT_GIVEN:
        return 'minus-double';
      case OrderStatus.APPROVED:
        return props.hasSignature ? 'thumbs-sign' : 'thumbs-up';
      case OrderStatus.REFUSED:
        return 'thumbs-down';
    }
  });
</script>